module.exports = __webpack_public_path__ + "static/media/robo-hurto_new.17a7bb1d.jpg";